var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c("entity-filter", {
        staticClass: "mb-n1",
        attrs: {
          isLoading: _vm.isLoading,
          useEvents: true,
          teams: _vm.teams,
          hideStatus: true,
          hideSearch: true
        },
        on: { change: _vm.filterChange }
      }),
      _vm.selectedEvent
        ? _c("event-time-table", {
            attrs: {
              event: _vm.event,
              "slot-data": _vm.filteredEventSlots,
              "monster-slots": _vm.monsterSlots,
              "show-monster-slots": true,
              "read-route-name": "editEventSlots",
              "read-only": _vm.isReadOnly
            },
            on: { slotSelected: _vm.handleSlotSelected }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }